import { useMemo } from 'react';
import { useQuery } from './useQuery';

export const useClaimPageQuery = () => {
  const query = useQuery();

  return useMemo(() => {
    const _sequenceNo = parseInt(query.get('sequenceNo') ?? '');
    const sequenceNo = Number.isNaN(_sequenceNo) ? undefined : _sequenceNo;

    return {
      sequenceNo,
      claimStatus: query.get('claimStatus') ?? undefined,
      claimId: query.get('claimId') ?? undefined,
      referenceNo: query.get('referenceNo') ?? undefined,
    };
  }, [query]);
};
